export default __webpack_public_path__ + "static/media/183.23ad4c40.jpg";